import PropTypes from 'prop-types';
import React, { useContext, useRef } from 'react';
import IfmsButton from './IfmsButton';
import ApplicationContext from '../ApplicationContext';
import PrimaryButton from './PrimaryButton';

function GreenButtonInputExcel({
  children = undefined,
  ...other
}: {
  children: React.ReactNode | string,
  [x: string]: any,
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const { onClick, handleFile, isText, isBlue, isPrimary,  
    //...remainingProps
   } = other;
  const appContext = useContext(ApplicationContext);
  const isType2 = appContext.suntekSettings?.company?.billingsTabVersion === 2;
  const baseClass = !other.notsetbackcolorwhenfocus ? 'ifms-primary-button' : 'ifms-primary-button b';
  async function handleClick() {
    if(onClick){
      if(!await onClick()) return;
    }
    if (inputRef && inputRef.current)
      inputRef.current.click();
  }
  function handleChangeUpload(e: any) {
    handleFile(e);
  }

  let bClass = baseClass;
  if (other.useOnlyIcon) bClass = 'ifms-icon-button'
  else if (!isPrimary) {
    if (isBlue) bClass = 'ifms-secondary-button';
    else bClass = 'ifms-green-button';
  }
  return (
      <>
        <IfmsButton {...other} size={other.size} baseClass={bClass} onClick={() => { handleClick() }}>
          {children}
        </IfmsButton>
        <input type='file' accept={isText ? '.txt' : '.xls, .xlsx'} ref={inputRef} style={{ display: 'none' }} onChange={e => handleChangeUpload(e)} />
      </>
  );
}

GreenButtonInputExcel.defaultProps = {
};

GreenButtonInputExcel.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'extrasmall']),
};

export default React.memo(GreenButtonInputExcel);

